import { IPersonalInfo, InputFieldConfig } from '../../../../../types';
import { StudentState } from '../../../../../store/student/types';

type Fields = Pick<IPersonalInfo, 'phoneNumber' | 'city' | 'country' | 'postCode' | 'homeAddress'>;

export type Visible = Record<'phoneNumber' | 'city' | 'country' | 'postCode' | 'homeAddress', boolean>;

type Mandatory = Record<'phoneNumber' | 'city' | 'country' | 'postCode' | 'homeAddress', boolean>;

export function getPageStatus(
  config: StudentState['config'],
  fields: Fields,
): {
  complete: boolean;
  visible: Visible;
} {
  const { phoneNumber, city, country, postCode, homeAddress } = fields;

  const {
    PhoneNumber: phoneNumberConfig,
    HomeAddress: homeAddressConfig,
    City: cityConfig,
    Postcode: postCodeConfig,
    Country: countryConfig,
  }: {
    PhoneNumber: InputFieldConfig;
    HomeAddress: InputFieldConfig;
    City: InputFieldConfig;
    Postcode: InputFieldConfig;
    Country: InputFieldConfig;
  } = config.Checklist.PersonalInfo.Page3;

  const visible: Visible = {
    phoneNumber: phoneNumberConfig?.visible ?? true,
    city: homeAddressConfig?.visible ?? true,
    country: cityConfig?.visible ?? true,
    postCode: postCodeConfig?.visible ?? true,
    homeAddress: countryConfig?.visible ?? true,
  };

  const mandatory: Mandatory = {
    phoneNumber: phoneNumberConfig?.mandatory ?? true,
    city: homeAddressConfig?.mandatory ?? true,
    country: cityConfig?.mandatory ?? true,
    postCode: postCodeConfig?.mandatory ?? true,
    homeAddress: countryConfig?.mandatory ?? true,
  };

  // prettier-ignore
  const complete = (!visible.phoneNumber || !mandatory.phoneNumber || phoneNumber !== '') &&
    (!visible.city || !mandatory.city || city !== '') &&
    (!visible.country || !mandatory.country || country !== '') &&
    (!visible.postCode || !mandatory.postCode || postCode !== '') &&
    (!visible.homeAddress || !mandatory.homeAddress || homeAddress !== '');

  return {
    complete,
    visible,
  };
}
